const mapping = {
  name: "like",
  ownerEmail: "like",
  createdAt: "gte,lte",
  tokenType: "eq",
  tokenTypeIn: "in",
  selected: "eq",
};

export const createFilterQuery = (
  filter: Array<{ id: string; value: any }>
) => {
  const query = filter.map(f => {
    const { id, value } = f;
    const type = mapping[id];
    if (type === "like") {
      return `${id}:${type}=${value}`;
    }
    if (type === "gte,lte") {
      const [start, end] = type.split(",");
      return `${id}:${start}=${value.startDate},${id}:${end}=${value.endDate}`;
    }
    if (type === "eq") {
      return `${id}:${type}=${value}`;
    }
    if (type === "in") {
      return `tokenType:${type}=${value.join(";")}`;
    }
    return "";
  });
  return query.join(",");
};
